import {Message} from 'iview';
import globalData from './Global';
//提示
function messageAlert(msg) {
  Message.error({
    content:msg,
    duration:3,
    closable:true,
    top: 80
  })
}
//各种提示
function alertTips(type,msg) {
  Message[type]({
    content:msg,
    duration:3,
    closable:true,
    top: 80
  })
}
//处理日期，返回格式20180623092541 -> 2018-06-23 09:25
function dealDate (dateTime) {
  let year = dateTime.toString().substr(0,4);
  let month = dateTime.toString().substr(4,2);
  let day = dateTime.toString().substr(6,2);
  let hours = dateTime.toString().substr(8,2);
  let minute = dateTime.toString().substr(10,2);
  return `${year}-${month}-${day}  ${hours}:${minute}`
}
//处理日期，返回格式20180623092541 -> 2018-06-23 09:25:30
function dealTime (dateTime) {
  let year = dateTime.toString().substr(0,4);
  let month = dateTime.toString().substr(4,2);
  let day = dateTime.toString().substr(6,2);
  let hours = dateTime.toString().substr(8,2);
  let minute = dateTime.toString().substr(10,2);
  let second = dateTime.toString().substr(12,2);
  return `${year}-${month}-${day}  ${hours}:${minute}:${second}`
}
//处理日期，返回格式20180623 -> 2018-06-23
function YearMonthDate (dateTime) {
  let year = dateTime.toString().substr(0,4);
  let month = dateTime.toString().substr(4,2);
  let day = dateTime.toString().substr(6,2);
  return `${year}-${month}-${day}`;
}
//处理以'/'开头的图片路径
function dealImgUrl(url) {
  if(/^\//gi.test(url)){
    return globalData.positionUrl + url;
  }else {
    return url;
  }
}
// input 聚焦全选文本内容
function selectedALLTxt(e) {
  e.currentTarget.select();
}

export {
  messageAlert,
  dealDate,
  dealImgUrl,
  YearMonthDate,
  selectedALLTxt,
  alertTips,
  dealTime
}



// WEBPACK FOOTER //
// ./src/common/common.js